// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// css
import '../../styles/components/common/CheckedList.scss';


const CheckedList = ({items}) => {

  const renderedItems = items.map((item, index) => {
    const classNames = classnames({
      'checked-list__item': true,
      'checked-list__item--checked': item.checked,
      'checked-list__item--warning': item.warning
    });

    return (
      <li key={index} className={classNames}>
        {item.label}
      </li>
    );
  });

  return (
    <ul className='checked-list'>
      {renderedItems}
    </ul>
  );
};

CheckedList.propTypes = {
  items: PropTypes.array.isRequired
};

export default CheckedList;



// WEBPACK FOOTER //
// ./src/components/common/CheckedList.js